import React, { useEffect, useState, useMemo } from 'react';
import { Trash2, Search } from 'lucide-react';
import {
  getInactiveEmployees,
  deleteEmployee,
} from '../../../services/admin/api';
import './employee.css';

const InactiveEmployeeList = () => {
  const [employees, setEmployees] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortColumn, setSortColumn] = useState('userid');
  const [sortOrder, setSortOrder] = useState('desc');
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState('');
    const [totalPages, setTotalPages] = useState(0);
    const [totalElements, setTotalElements] = useState(0);
    const [isAsc , setIsAsc] = useState(false); 

 
   const fetchEmployees = async (page = 0, size = itemsPerPage , sortColumn = sortColumn, sort) => {
      try {
        setLoading(true);
        const res = await getInactiveEmployees(page, size , sortColumn, sort ); 
        if(res.data?.content){
          setEmployees(res.data.content || []);
          setTotalPages(res.data.totalPages);
          setTotalElements(res.data.totalElements);
          setCurrentPage(res.data.number + 1); // backend is 0-based
        }
  
      } catch (error) {
        setEmployees([]);
        setTotalPages(1)
        setCurrentPage(1);
        setFeedbackMessage(' Failed to load employees.');
        // triggerFeedback();
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
        fetchEmployees(currentPage - 1, itemsPerPage, sortColumn, isAsc); 
      }, [currentPage, itemsPerPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, itemsPerPage]);

  const renderSortArrow = (field) => {
    return (
      <span className="sort-icons">
        <span
          className={`arrow ${sortColumn === field && sortOrder === 'asc' ? 'active' : ''
            }`}
        >
          ↑
        </span>
        <span
          className={`arrow ${sortColumn === field && sortOrder === 'desc' ? 'active' : ''
            }`}
        >
          ↓
        </span>
      </span>
    );
  };

  const handleSort = async (column) => {
    let sort = !isAsc;
    setIsAsc((prev) => !prev);
    setSortOrder(sort ? "asc" : "desc")
    setSortColumn(column)
    await fetchEmployees(currentPage - 1, itemsPerPage, column, sort);
  };


  const filteredEmployees = useMemo(() => {
    return [...employees]
      .filter((emp) =>
        emp.id?.toString().includes(searchTerm) ||
        emp.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        emp.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        emp.contact?.toString().includes(searchTerm)
      )
      // .sort((a, b) => {
      //   if (!sortColumn) return 0;

      //   const valA = a[sortColumn];
      //   const valB = b[sortColumn];

      //   if (valA == null) return 1;
      //   if (valB == null) return -1;

      //   if (typeof valA === 'string' && typeof valB === 'string') {
      //     return sortOrder === 'asc'
      //       ? valA.toLowerCase().localeCompare(valB.toLowerCase())
      //       : valB.toLowerCase().localeCompare(valA.toLowerCase());
      //   }

      //   return sortOrder === 'asc'
      //     ? valA - valB
      //     : valB - valA;
      // });

  }, [employees, searchTerm, sortColumn, sortOrder]);


  // const paginatedEmployees = useMemo(() => {
  //   const start = (currentPage - 1) * itemsPerPage;
  //   return filteredEmployees.slice(start, start + itemsPerPage);
  // }, [filteredEmployees, currentPage, itemsPerPage]);

  // const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);

  const handleDelete = (employee) => {
    setSelectedEmployee(employee);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      await deleteEmployee(selectedEmployee.id);
      setFeedbackMessage('Employee deleted successfully.');
      fetchEmployees();
    } catch {
      setFeedbackMessage('Failed to delete employee.');
    } finally {
      setShowDeleteModal(false);
      setSelectedEmployee(null);
      setShowFeedbackModal(true);
    }
  };

  return (
    <div className="admin-employee-table-wrapper">

      <div className="clinet-table-controls">
        <div className="entries-select">
          Show
          <select
            value={itemsPerPage}
            onChange={(e) => setItemsPerPage(Number(e.target.value))}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
          entries
        </div>

        <div className="client-search-input-wrapper">
          <input
            type="text"
            placeholder="Search employee by name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Search className="client-search-icon" size={18} />
        </div>
      </div>

      <table className="admin-employee-table">
        <thead>
          <tr>
            <th onClick={() => handleSort('userid')}>
              Agent ID {renderSortArrow('userid')}
              {/* {sortColumn === 'userid' ? (sortOrder === 'asc' ? '↑' : '↓') : '↑↓'} */}
            </th>
            <th onClick={() => handleSort('username')}>
              Name {renderSortArrow('username')}
              {/* {sortColumn === 'username' ? (sortOrder === 'asc' ? '↑' : '↓') : '↑↓'} */}
            </th>
            <th onClick={() => handleSort('email')}>
              Email {renderSortArrow('email')}
              {/* {sortColumn === 'email' ? (sortOrder === 'asc' ? '↑' : '↓') : '↑↓'} */}
            </th>
            <th onClick={() => handleSort('phonenumber')}>
              Contact {renderSortArrow('phonenumber')}
              {/* {sortColumn === 'phonenumber' ? (sortOrder === 'asc' ? '↑' : '↓') : '↑↓'} */}
            </th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <td colSpan="5" className="no-data loading-text">
                Loading Inactive Employees...
              </td>
            </tr>
          ) : filteredEmployees.length === 0 ? (
            <tr>
              <td colSpan="5" className="no-data">
                No inactive employees found.
              </td>
            </tr>
          ) : (
            filteredEmployees.map((employee) => (
              <tr key={employee.id}>
                <td>{employee.id}</td>
                <td>{employee.name}</td>
                <td>{employee.email}</td>
                <td>{employee.contact}</td>
                <td>
                  <button
                    title="Delete"
                    onClick={() => handleDelete(employee)}
                    className="admin-action-btn delete"
                  >
                    <Trash2 size={16} />
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>

      </table>

      <div className="pagination">
        <div className="pagination-summary">
          Showing {(currentPage - 1) * itemsPerPage + 1}
          {' '}to{' '}
          {Math.min(currentPage * itemsPerPage, totalElements)}
          of {totalElements} entries
        </div>

       <div className="pagination-buttons-user">
  {/* Previous */}
  <button
    className="page-btn"
    onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
    disabled={currentPage === 1}
  >
    Previous
  </button>

  {/* Page Numbers */}
  {Array.from({ length: totalPages }, (_, index) => {
    const pageNumber = index + 1;
    return (
      <button
        key={pageNumber}
        className={`page-btn ${currentPage === pageNumber ? "active" : ""}`}
        onClick={() => setCurrentPage(pageNumber)}
      >
        {pageNumber}
      </button>
    );
  })}

  {/* Next */}
  <button
    className="page-btn"
    onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))}
    disabled={currentPage === totalPages || totalPages === 0}
  >
    Next
  </button>
</div>
      </div>

      {showDeleteModal && selectedEmployee && (
        <div className="admin-modal-overlay">
          <div className="admin-modal-content">
            <h3>Confirm Deletion</h3>
            <p>
              Are you sure you want to permanently delete{' '}
              <span style={{ color: '#ff5252' }}>{selectedEmployee.name}</span>?
            </p>
            <div className="admin-modal-buttons">
              <button className="admin-assign-cancel" onClick={confirmDelete}>
                Delete
              </button>
              <button
                className="admin-assign-confirm"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {showFeedbackModal && (
        <div className="admin-modal-overlay">
          <div className="admin-modal-content">
            <p>{feedbackMessage}</p>
            <div className="admin-popup-modal-buttons">
              <button
                className="admin-popup-ok-btn"
                onClick={() => setShowFeedbackModal(false)}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default InactiveEmployeeList;
